import Storage from 'app/common/lib/storage';
import { featureFlagClient, FlagSet } from '@trello/feature-flag-client';

const FEATURE_FLAGS_KEY = 'featureFlagSnapshot';

// Exclude entries with false values from the recorded
// flags
function filterFlags(flags: FlagSet): Partial<FlagSet> {
  return Object.entries(flags)
    .filter(([key, value]) => value)
    .reduce((combined: FlagSet, [key, value]) => {
      combined[key] = value;

      return combined;
    }, {});
}

function writeFlagsToLocalStorage() {
  const { remote, overrides } = featureFlagClient.all();

  Storage.set(FEATURE_FLAGS_KEY, {
    remote: filterFlags(remote),
    overrides: filterFlags(overrides),
  });
}

export function recordFeatureFlags() {
  const { client } = featureFlagClient;

  client.on('initialized', writeFlagsToLocalStorage);
  // NOTE: This will open a streaming connection to LaunchDarkly to receive
  // changes
  client.on('change', writeFlagsToLocalStorage);
}
